import React, {Component} from 'react';
import {Redirect,Link} from 'react-router-dom'
import {Table,message,PageHeader,Button,Modal,Form,Input,Select,Descriptions,Tag,Comment,Breadcrumb} from 'antd';
import {ExclamationCircleOutlined,CloseOutlined,PlusOutlined,UserOutlined} from '@ant-design/icons';
// import zhCN from 'antd/es/locale/zh_CN';
import reqwest from 'reqwest'
import moment from 'moment'; 
// import Highlighter from 'react-highlight-words';
import {Header} from '../Header.jsx'
import {Footer} from '../Footer.jsx'
import Nav from './Nav.jsx'
import {CheckLogin} from '../Common.jsx'
import BuildTitle from '../BuildTitle.jsx'

moment.locale('zh-cn');



export default class Hpo extends Component {
	constructor(props) {
	    super(props);
		let token = '';
		let user_name = '';
		let role = '';
		let check_result = CheckLogin();
		if (check_result !== false){
			token = check_result.Authorization;
	    	user_name = check_result.user_name;
	    	role = check_result.role;
		}
		this.state = {
			...props,
			'L1': 'crog',
			'L2' : 'hpos',
			'token' : token,
			'user_name': user_name,
			'role': role,
			'redirect' : '',
			'hpo_id' : props.match.params.hpo_id,
			'hpo': {},
			'hpo_column':[
				{'title':'HPO', 'dataIndex':'id',render:(text) => {
					return <Link to={`/crog/hpo/${text}`} target="_blank">{text}</Link>
				}},
				{'title':'中文名称', 'dataIndex':'name_chs'},
				{'title':'英文名称', 'dataIndex':'name'},
			],
			'loading': true,
			'children': [],
			'parents': [],
		}
	}
	componentDidMount(){
		if(this.state.token){
			this.fetch();
		}
	}


	fetch = () => {
		reqwest({
			url: `/api/crog/hpo/${this.state.hpo_id}`,
			method: 'GET',
			headers: {
				'Authorization': this.state.token,
			},
			type: 'json',
		}).then(
			(data) => {
				if(data.status === 1){
					this.setState({
						'loading': false,
						'hpo': data.result,
					})
					if(data.result['children']){
						this.getHPObyID(data.result['children'], 'children');
					}
					if(data.result['parents']){
						this.getHPObyID(data.result['parents'], 'parents');
					}
				}else{
					message.error(data.msg);
					this.setState({
						'loading': false,
					})
				}
			},
			(err,data) => {
				if(err.response === 'Unauthorized.'){
					console.log('Token invalid');
					localStorage.removeItem('Authorization');
					this.setState({
						'redirect': '/login'
					})
					message.error('登录失效');
					return false;
				}
				message.error('Network error');
				this.setState({'loading': false})
			}
		);
	}

	
	getHPObyID = (ids, key) => {
		reqwest({
			url: `/api/crog/hpos`,
			method: 'GET',
			headers: {
				'Authorization': this.state.token,
			},
			type: 'json',
			data:{id: ids.join(',')}
		}).then(
			(data) => {
				if(data.status === 1){
					let res = {
						'loading': false,
					}
					res[key] = data.results.data;
					this.setState(res)
				}else{
					message.error(data.msg);
					this.setState({
						'loading': false,
					})
				}
			},
			(err,data) => {
				if(err.response === 'Unauthorized.'){
					console.log('Token invalid');
					localStorage.removeItem('Authorization');
					this.setState({
						'redirect': '/login'
					})
					message.error('登录失效');
					return false;
				}
				message.error('Network error');
				this.setState({'loading': false})
			}
		);
	}

	

	status_view = () => {
		let status = this.state.hpo['status'];
		if(!status){
			return ''
		}
		if(status === 1){ return '未校对';}
		if(status === 2){ return '校对中';}
		if(status === 3){ return '完成校对';}
		if(status === 4){ return '评审通过';}
		if(status === 9){ return '已废弃';}
		return status;
	}


	// 关键字的添加
	removeKey = (key) => {
		let that = this;
		Modal.confirm({
			title: '您确信要删除该标签?',
			icon: <ExclamationCircleOutlined />,
			onOk() {
				that.postKeyRemove(key);
			},
		});
		return false;
	}
	postKeyRemove = (key) => {
		reqwest({
			url: `/api/crog/hpo/${this.state.hpo_id}/key`,
			method: 'DELETE',
			headers: {
				'Authorization': this.state.token,
			},
			type: 'json',
			data: {'key' : key}
		}).then(
			(data) => {
				if(data.status === 1){
					message.success('添加成功');
					this.fetch()
				}else{
					message.error(data.msg);
					this.setState({
						'loading': false,
					})
				}
			},
			(err,data) => {
				if(err.response === 'Unauthorized.'){
					console.log('Token invalid');
					localStorage.removeItem('Authorization');
					this.setState({
						'redirect': '/login'
					})
					message.error('登录失效');
					return false;
				}
				message.error('Network error');
				this.setState({'loading': false})
			}
		);
	}
	showInput2 = () =>{
		this.setState({
			'key_input': true
		}, () => {
			this.refs.key_input.focus()
		})
	}
	addNewKey = (e) => {
		let value = e.target.value;
		if(!value){
			message.error('请输入基因别名');
			return true;
		}
		if(this.state.hpo['keys'].indexOf(value) !== -1){
			message.error('您输入的关键字已经存在');
			return true;
		}
		reqwest({
			url: `/api/crog/hpo/${this.state.hpo_id}/key`,
			method: 'POST',
			headers: {
				'Authorization': this.state.token,
			},
			type: 'json',
			data: {'key' : value}
		}).then(
			(data) => {
				if(data.status === 1){
					message.success('添加成功');
					this.fetch()
					this.setState({'key_input': false})
				}else{
					message.error(data.msg);
					this.setState({
						'loading': false,
					})
				}
			},
			(err,data) => {
				if(err.response === 'Unauthorized.'){
					console.log('Token invalid');
					localStorage.removeItem('Authorization');
					this.setState({
						'redirect': '/login'
					})
					message.error('登录失效');
					return false;
				}
				message.error('Network error');
				this.setState({'loading': false})
			}
		);
	}


	
	// 添加评论
	openCommentModal = () => {
		this.setState({'add_comment_modal': true});
	}
	closeCommentModal = () => {
		this.setState({'add_comment_modal': false});
	}
	addComment = () => {
		let form =this.refs.add_comment;
		let that = this;
		form.validateFields().then((data) => {
			if(! data['comment']){
				message.error('请输入评论');
				return false;
			}

			reqwest({
				url: `/api/crog/hpo/${that.state.hpo_id}/comment`,
				method: 'POST',
				headers: {
					'Authorization': that.state.token,
				},
				type: 'json',
				data: data
			}).then(
				(data) => {
					if(data.status === 1){
						message.success('添加成功');
						that.fetch()
						that.setState({'add_comment_modal': false})
					}else{
						message.error(data.msg);
						that.setState({
							'loading': false,
						})
					}
				},
				(err,data) => {
					if(err.response === 'Unauthorized.'){
						console.log('Token invalid');
						localStorage.removeItem('Authorization');
						that.setState({
							'redirect': '/login'
						})
						message.error('登录失效');
						return false;
					}
					message.error('Network error');
					that.setState({'loading': false})
				}
			);


		})
	}


	
	// 修改记录状态
	changeState = (value) => {
		reqwest({
			url: `/api/crog/hpo/${this.state.hpo_id}/status`,
			method: 'PATCH',
			headers: {
				'Authorization': this.state.token,
			},
			type: 'json',
			data: {'status': value}
		}).then(
			(data) => {
				if(data.status === 1){
					message.success('修改成功');
					this.fetch()
				}else{
					message.error(data.msg);
					this.setState({
						'loading': false,
					})
				}
			},
			(err,data) => {
				if(err.response === 'Unauthorized.'){
					console.log('Token invalid');
					localStorage.removeItem('Authorization');
					this.setState({
						'redirect': '/login'
					})
					message.error('登录失效');
					return false;
				}
				message.error('Network error');
				this.setState({'loading': false})
			}
		);
	}


	openEditModal = () => {
		this.setState({'edit_modal': true})
	}
	closeEditModal = () => {
		this.setState({'edit_modal': false})
	}
	editHPO = () => {
		let form =this.refs.edit_hpo;
		let that = this;
		form.validateFields().then((data) => {
			reqwest({
				url: `/api/crog/hpo/${that.state.hpo_id}`,
				method: 'PATCH',
				headers: {
					'Authorization': that.state.token,
				},
				type: 'json',
				data: data
			}).then(
				(data) => {
					if(data.status === 1){
						message.success('修改成功');
						that.fetch()
						that.setState({'edit_modal': false})
					}else{
						message.error(data.msg);
						that.setState({
							'loading': false,
						})
					}
				},
				(err,data) => {
					if(err.response === 'Unauthorized.'){
						console.log('Token invalid');
						localStorage.removeItem('Authorization');
						that.setState({
							'redirect': '/login'
						})
						message.error('登录失效');
						return false;
					}
					message.error('Network error');
					that.setState({'loading': false})
				}
			);
		})
	}
	

	
	render(){
		if(! this.state.token){
			return <Redirect to="/login"/>
		}
		if(this.state.redirect){
			return <Redirect to={this.state.redirect}/>
		}
		return (
			<div>
				<Header {...this.state} />
				<div className="max-width">
					<Nav L2={this.state.L2} />
					<Breadcrumb style={{'marginTop':'9px'}}>
						<Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
						<Breadcrumb.Item><Link to={`/crog/hpos`}>HPO列表</Link></Breadcrumb.Item>
						<Breadcrumb.Item>{this.state.hpo_id}</Breadcrumb.Item>
					</Breadcrumb>
					<PageHeader title={this.state.hpo_id} style={{padding:0,marginTop:10}} >
						<Descriptions size="small" column={3}  style={{'width':'800px'}}>
	        				<Descriptions.Item label="创建时间">{this.state.hpo['date_created']} </Descriptions.Item>
	        				<Descriptions.Item label="最后修改">{this.state.hpo['date_last_update']} </Descriptions.Item>
	        				<Descriptions.Item label="状态">
	        					<Select bordered={false} 
	        						size="small"
	        						onChange={this.changeState}
	        						value={ this.state.hpo['status'] ? this.state.hpo['status'].toString() : ''}
	        						style={{'width':'100px'}}
	        					>
	        						<Select.Option value="1">未校对</Select.Option>
	        						<Select.Option value="2">校对中</Select.Option>
	        						<Select.Option value="3">完成校对</Select.Option>
	        						<Select.Option value="4">评审通过</Select.Option>
	        						<Select.Option value="9">已废弃</Select.Option>
	        					</Select>
	        				</Descriptions.Item>
	        			</Descriptions>
					</PageHeader>

					<PageHeader title="基本信息" style={{paddingLeft:0,paddingRight:0}} 
						extra={[
							<Button key="1" type="primary" onClick={this.openEditModal} >编辑</Button>,
						]}
					>
						<Descriptions size="small" column={1} bordered className="table_list2">
	        				<Descriptions.Item label="HPO ID">{this.state.hpo['id']} </Descriptions.Item>
	        				<Descriptions.Item label="英文名">{this.state.hpo['name']} </Descriptions.Item>
	        				<Descriptions.Item label="中文名">{this.state.hpo['name_chs']} </Descriptions.Item>
	        				<Descriptions.Item label="英文描述">{this.state.hpo['definition']} </Descriptions.Item>
	        				<Descriptions.Item label="中文描述">{this.state.hpo['definition_chs']} </Descriptions.Item>
	        			</Descriptions>
	        		</PageHeader>
	        		<PageHeader title="关键字" style={{paddingLeft:0,paddingRight:0}} >
						{
							this.state.hpo['keys'] ?  this.state.hpo['keys'].map((item,index) => {
								return <Tag key={item} >{item}  <CloseOutlined onClick={e => this.removeKey(item)} /></Tag>
							}) : ''
						}
						
						{
							this.state.key_input ? (
								<Input size="small" className="tag-input" ref="key_input" onPressEnter={this.addNewKey}  onBlur={this.clearInput} />
							) : (
								<Tag className="site-tag-plus" onClick={this.showInput2}>
									<PlusOutlined /> 关键字
								</Tag>
							)
						}
								
	        		</PageHeader>

	        		<PageHeader title="上一级HPO" style={{paddingLeft:0,paddingRight:0}} >
						<Table 
							bordered 
							loading={this.state.loading} 
							rowKey="id" 
							size="small" 
							columns={this.state.hpo_column} 
							dataSource={this.state.parents}
						    locale={{emptyText:'No Data',}}
							pagination={false}
						/>
	        		</PageHeader>

	        		<PageHeader title="下一级HPO" style={{paddingLeft:0,paddingRight:0}} >
						<Table 
							bordered 
							loading={this.state.loading} 
							rowKey="id" 
							size="small" 
							columns={this.state.hpo_column} 
							dataSource={this.state.children}
						    locale={{emptyText:'No Data',}}
							pagination={false}
						/>
	        		</PageHeader>

	        		<PageHeader title="Comments" style={{paddingLeft:0,paddingRight:0}} 
	        			extra={[
							<Button key="1" type="primary" onClick={this.openCommentModal} >添加评论</Button>,
						]}
	        		>
	        			{
	        				this.state.hpo['comments'] && this.state.hpo['comments'].map((item,index) => {
	        					return <div style={{border:'1px solid #f0f0f0','paddingRight':'16px','paddingLeft':'16px'}}>
	        						<Comment content={item['comment']} author={item['email']} datetime={item['date']} avatar={<UserOutlined />}  />
	        					</div>
	        				})
	        			}
	        		</PageHeader>

				</div>
				<Modal
		        	title={<BuildTitle visible={this.state.add_comment_modal} id="add_comment_modal" title="添加评论" />}
					visible={this.state.add_comment_modal}
					onCancel={this.closeCommentModal}
					onOk={this.addComment}
					maskClosable={false}
					destroyOnClose={true}
					afterClose={() => {
			            try {
							document.getElementById('add_comment_modal').style.transform = "translate(0px, 0px)";
						} catch (e) {}
					}}
				>
					<Form
						style={{marginTop:'0px'}}
						ref="add_comment"
						layout="horizontal"
						initialValues={{}}
						labelCol = {{ span: 4 }}
						wrapperCol = {{ span: 24 }}
						labelAlign="left"
					>
						<Form.Item name="comment" label="" rules={[{ required: true }]}>
							<Input.TextArea rows={5} />
						</Form.Item>
					</Form>
				</Modal>

				<Modal
		        	title={<BuildTitle visible={this.state.edit_modal} id="edit_modal" title="编辑HPO" />}
					visible={this.state.edit_modal}
					onCancel={this.closeEditModal}
					onOk={this.editHPO}
					maskClosable={false}
					destroyOnClose={true}
					afterClose={() => {
			            try {
							document.getElementById('edit_modal').style.transform = "translate(0px, 0px)";
						} catch (e) {}
					}}
				>
					<Form
						style={{marginTop:'0px'}}
						ref="edit_hpo"
						layout="horizontal"
						initialValues={{...this.state.hpo}}
						labelCol = {{ span: 4 }}
						wrapperCol = {{ span: 24 }}
						labelAlign="left"
					>
						<Form.Item name="name_chs" label="英文名称" rules={[{ required: true }]}>
							<Input />
						</Form.Item>
						<Form.Item name="name" label="中文名称" rules={[{ required: false }]}>
							<Input />
						</Form.Item>
						<Form.Item name="definition" label="英文描述" rules={[{ required: false }]}>
							<Input.TextArea rows={5} />
						</Form.Item>
						<Form.Item name="definition_chs" label="中文描述" rules={[{ required: false }]}>
							<Input.TextArea rows={5} />
						</Form.Item>
					</Form>
				</Modal>
				<Footer />
			</div>
		)
	}
}